import { Link } from 'react-router-dom';
import PhoneInputGroup from '../common/PhoneInputGroup';


const ContactInformation = ({ formik, countries, handleCustomerCountryChange }) => {

    const renderErrorMessage = (fieldName) => {
        if (formik.touched[fieldName] && formik.errors[fieldName]) {
            return (
                <div className="error-message" role="alert">
                    <i className="fas fa-exclamation-circle"></i>
                    <span>{formik.errors[fieldName]}</span>
                </div>
            );
        }
        return null;
    };

    const countryOptions = countries.map(country => ({
        value: country.id,
        label: country.name,
        iso2: country.iso2,
        phone_code: country.phone_code
    }));


    return (
        <div className="checkout-step">
            <div className="step-header">
                <h3>Contact Information</h3>
                <p className="step-subtitle">
                    Already have an account?
                    <Link to="/login" className="ms-2"> Log in</Link>
                </p>

            </div>
            <div className="step-content">
                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control ${formik.touched.contactName && formik.errors.contactName ? 'is-invalid' : ''}`}
                        placeholder="Name *"
                        name="contactName"
                        value={formik.values.contactName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.contactName && formik.errors.contactName && (
                        <div className="text-danger">{formik.errors.contactName}</div>
                    )}
                </div>

                <div className="form-group">
                    <input
                        type="email"
                        className={`form-control ${formik.touched.contactEmail && formik.errors.contactEmail ? 'is-invalid' : ''}`}
                        placeholder="Email Address *"
                        name="contactEmail"
                        value={formik.values.contactEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.contactEmail && formik.errors.contactEmail && (
                        <div className="text-danger">{formik.errors.contactEmail}</div>
                    )}
                </div>

                <div className="row">
                    <div className="col-12">
                        <PhoneInputGroup
                            formik={formik}
                            countryName="contactCountry"
                            phoneName="contactPhone"
                            countries={countries}
                            onCountryChange={handleCustomerCountryChange}
                            showLabel={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactInformation; 